import { takeEvery } from 'redux-saga/effects';
import { AdminMarketsApi } from 'api';
import { sagasHandlersFactory } from 'store/entities/utils';
import * as actions from './actions';

const handleGetMarketNeighborhoodsRequest = sagasHandlersFactory.createGetManyRequestHandler({
  actions: actions.getAdminMarketNeighborhoods,
  request: AdminMarketsApi.getAdminMarketNeighborhoods,
  requestArgsBuilder: (action) => action.payload.params.market,
  transformResponse: (response) => response.results,
});

export default function* adminMarketNeighborhoodsSagas() {
  yield takeEvery(actions.getAdminMarketNeighborhoods.request.type, handleGetMarketNeighborhoodsRequest);
}
